import React from 'react';
import { Tabs, Row, Col, Input, Button, DatePicker, Table, Pagination } from 'antd';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';

const TabPane = Tabs.TabPane;

const store = ['ecodeCollectStore'];
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'collect-mycollect',
  }

  componentDidMount() {
    const { ecodeCollectStore: { getCollectList } } = this.props;
    getCollectList();
  }

  componentWillUnmount() {
    const { ecodeCollectStore: { initSearch } } = this.props;
    initSearch();
  }

  columns = () => {
    const columns = [
      {
        title: '应用名称',
        dataIndex: 'title',
        key: 'title',
      },
      {
        title: '收藏日期',
        dataIndex: 'createDate',
        key: 'createDate',
      },
      {
        title: '简介',
        dataIndex: 'description',
        key: 'description',
        width: '30%',
      },
      {
        title: '简介',
        dataIndex: 'setting',
        key: 'setting',
        width: '20%',
        render: (text, record, index) => {
          return (
            <span
              className="collect-btns"
              onClick={() => this.deleteCollect(record.appId)}
            >取消收藏</span>
          )
        }
      }
    ]
    return columns;
  }

  deleteCollect = (id) => {
    const { ecodeCollectStore: { deleteCollect, getCollectList } } = this.props;
    deleteCollect({appId: id}).then((data => getCollectList()));
  }

  onChange = key => {
    const { ecodeCollectStore: { setMobxState, initSearch } } = this.props;
    initSearch();
    setMobxState({ demoType: key });
    this.onSearch();
  }

  onPageChange = (pageNum, pageSize) => {
    const { ecodeCollectStore: { setMobxState } } = this.props;
    setMobxState({ pageSize, pageNum });
    this.onSearch();
  }

  onSearch = () => {
    const { ecodeCollectStore: { getCollectList } } = this.props;
    getCollectList();
  }

  onReset = () => {
    const { ecodeCollectStore: { initSearch } } = this.props;
    initSearch();
    this.onSearch();
  }

  getSearch = () => {
    const { ecodeCollectStore : { setMobxState, title, createDate } } = this.props;
    const searchList = [
      {
        key: 'title',
        label: '应用名称：',
        value: <Input value={title} onChange={e => setMobxState({ title: e.target.value })} placeholder="请输入应用名称"/>
      },
      {
        key: 'date',
        label: '收藏日期：',
        value: <DatePicker style={{width: '100%'}} onChange={(date, dateString) => setMobxState({ createDate: dateString })} />
      }
    ]
    return searchList;
  }

  render() {
    const { prefixCls, ecodeCollectStore: { demoType, collectList, loading, pageSize, pageNum, collectCount } } = this.props;
    const searchList = this.getSearch();
    return (
      <div className={prefixCls}>
        <div className={`${prefixCls}-header`}>
          <Tabs activeKey={demoType} onChange={this.onChange}>
            <TabPane tab="门户主题" key="portalTheme" />
            <TabPane tab="流程表单" key="workflowChart" />
            <TabPane tab="定制开发" key="default" />
          </Tabs>
        </div>
        <div className={`${prefixCls}-body`}>
          <Row className={`${prefixCls}-search`}>
            {
              searchList.map(item => {
                return (
                  <Col key={item.key} span={8} className={`${prefixCls}-search-col`}>
                    <Col span={7} className={`${prefixCls}-search-label`}>
                      <label>{item.label}</label>
                    </Col>
                    <Col span={17} className={`${prefixCls}-search-value`}>
                      {item.value}
                    </Col>
                  </Col>
                )
              })
            }
            <Col span={8} className={`${prefixCls}-search-btns`}>
              <Button type="primary" onClick={this.onSearch} >搜索</Button>
              <Button onClick={this.onReset} >重置</Button>
            </Col>
          </Row>
          <div className={`${prefixCls}-table`}>
            <Table
              rowKey={"appId"}
              loading={loading}
              dataSource={toJS(collectList)}
              columns={this.columns()}
              pagination={false}
            />
            {
              Array.isArray(toJS(collectList)) && collectList.length > 0 && 
                <Pagination
                  className={`${prefixCls}-pagination`}
                  pageSize={pageSize}
                  current={pageNum}
                  total={collectCount}
                  showTotal={(total) => `共${total}条`}
                  onChange={this.onPageChange}
                  onShowSizeChange={this.onPageChange}
                  showQuickJumper
                  showSizeChanger
                />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Main


// WEBPACK FOOTER //
// ./src/components/collect/MyCollect.js